import React, { useEffect, useState } from "react"
import API from "@/common/API"
import { parsedUser } from "@/common/GetCurrentUser"
import moment from "moment"
import { useTranslation } from "react-i18next"

const SummaryVehicleVisits = props => {
  const { t } = useTranslation()
  const [record, setRecord] = useState({})
  const [show, setShow] = useState(false)
  const user = parsedUser()
  const bindDataRemote = async () => {
    try {
      let Query = "OrganizationId=" + (user?.OrganizationId || "")

      var request = await API.getAction("place/SummaryVehicleVisits", Query)
      if (request?.data?.status === "ok") {
        setRecord(request.data.response || {})
      }
    } catch (ex) {
      console.error("Error loading SummaryVehicleVisits:", ex)
    }
  }

  useEffect(() => {
    bindDataRemote()
  }, [])
  return (
    <>
      <button
        className="ms-2 btn btn-outline-primary btn-sm ms-2"
        onClick={() => {
          setShow(!show)
        }}
      >
        {t("Vehicle Visits")}
      </button>
      {show && (
        <div className="badge me-2 text-dark">
          <i
            className={"fa fa-circle " + " ms-2  me-2"}
            style={{
              color: "black",
            }}
          ></i>
          <span className="d-none d-md-inline">{t("Places with visits")}</span>{" "}
          {record.placesWithVisits}
          <i
            className={"fa fa-circle " + " ms-2  me-2"}
            style={{
              color: "black",
            }}
          ></i>
          <span className="d-none d-md-inline">{t("Total")}</span>{" "}
          {record.totalVisits}
          <span className="mx-2">|</span>
          <i
            className={"fa fa-circle " + " ms-2  me-2"}
            style={{
              color: "#7ac2ff",
            }}
          ></i>
          <span className="d-none d-md-inline">{t("7 days:")}</span>{" "}
          {record.summary?.visitLast7Days}
          <i
            className={"fa fa-circle " + " ms-2  me-2"}
            style={{
              color: "#034986ff",
            }}
          ></i>
          <span className="d-none d-md-inline">{t("14 days:")}</span>{" "}
          {record.summary?.visitLast14Days}
          <i
            className={"fa fa-circle " + " ms-2  me-2"}
            style={{
              color: "#002f58ff",
            }}
          ></i>
          <span className="d-none d-md-inline">{t("30 days:")}</span>{" "}
          {record.summary?.visitLast30Days}
        </div>
      )}
    </>
  )
}

export default SummaryVehicleVisits
